import { Link as LinkCore, LinkProps as LinkPropsCore } from 'ia-react-core';
import React, { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import redirectToUtils from '../../utils/redirectTo';

export interface LinkProps extends LinkPropsCore {
  redirectTo?: string;
  children: ReactNode;
}

const Link: FC<LinkProps> = ({ redirectTo, children, ...props }) => {
  const navigate = useNavigate();

  const newProps = redirectTo ? {
    ...props, href: redirectTo, onClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => { e?.preventDefault(); redirectToUtils(redirectTo, navigate); },
  } : props;

  return (
    <LinkCore {...newProps}>{children}</LinkCore>
  );
};

export default Link;
